const TextChip = ({text, disabled}) => {
  return (
    !disabled ? <span className="py-[6px] sm:px-[12px] sm:inline-block w-full sm:w-auto text-center font-bold text-xs text-white rounded-[2px] bg-[#3A7DFF]">{text}</span>
    : <span className="py-[6px] sm:px-[12px] sm:inline-block w-full sm:w-auto text-center font-bold text-xs text-white rounded-[2px] bg-[#ADADAD]"> {text} </span>
  )
}

export default TextChip;